export default {
    encoding: [
        {
            name: 'x',
            type: '[time | number | string]',
            desc: 'Specify the dataSource applied to the x-axis.',
            defaultValue: 'primary[0]',
            isRequired: 'true',
        },
        {
            name: 'y',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the y-axis.',
            defaultValue: 'primary[1:]',
            isRequired: 'true',
        },
        {
            name: 'y2',
            type: '[number | string]',
            desc: `Specify the dataSource applied to the y2-axis.`,
            isRequired: 'false',
        },
        {
            name: 'annotationX',
            type: '[time | number | string]',
            desc: 'Specify the dataSource applied to the event annotation on the x-axis.',
            isRequired: 'false',
        },
        {
            name: 'annotationLabel',
            type: '[string]',
            desc: 'Specify the message displayed on the annotation label.',
            isRequired: 'false',
        },
        {
            name: 'annotationColor',
            type: '[string]',
            desc: `Assign a color to an annotation event. For example, "0xffff00".`,
            isRequired: 'false',
        },
    ],
    events: [
        {
            name: 'point.click',
            desc: 'trigger when user clicks a data point',
        },
        {
            name: 'legend.click',
            desc: 'trigger when user clicks a chart legend',
        },
        {
            name: 'range.select',
            desc: 'trigger when user makes a selection',
        },
    ],
};
